import { valNumber, valSchema, valString } from '@bymason-private/legacy-pattern-components';

export enum Fields {
  Group = 'group',
  TimeZone = 'timeZone',
  ExpirationDays = 'expirationDays',
  WifiLogin = 'wifiLogin',
  WifiPassword = 'wifiPassword',
  WifiAuthType = 'wifiAuthType',
}
const REQUIRED_MSG = 'Required';
const EXPIRATION_DAYS_TYPE_ERROR = 'Must be a number';
const MIN_EXPIRATIONDAYS_MSG = 'Must be a positive number';
const MAX_EXPIRATIONDAYS_MSG = 'Cannot be longer than 30 days';
const DEFAULT_TZ_CODE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const schema = valSchema().shape({
  [Fields.Group]: valString().required(REQUIRED_MSG),
  [Fields.TimeZone]: valString().required(REQUIRED_MSG),
  [Fields.ExpirationDays]: valNumber()
    .required(REQUIRED_MSG)
    .typeError(EXPIRATION_DAYS_TYPE_ERROR)
    .min(1, MIN_EXPIRATIONDAYS_MSG)
    .max(30, MAX_EXPIRATIONDAYS_MSG),

  [Fields.WifiLogin]: valString(),
  [Fields.WifiPassword]: valString(),
  [Fields.WifiAuthType]: valString().when(Fields.WifiPassword, {
    is: (val: string) => !!val,
    then: valString().required(REQUIRED_MSG),
  }),
});

export interface QRCodeFormModel {
  [Fields.Group]: string;
  [Fields.TimeZone]: string;
  [Fields.ExpirationDays]: number;
  [Fields.WifiLogin]: string;
  [Fields.WifiPassword]: string;
  [Fields.WifiAuthType]: string;
}

export const initialValues: QRCodeFormModel = {
  [Fields.Group]: '',
  [Fields.TimeZone]: DEFAULT_TZ_CODE,
  [Fields.ExpirationDays]: 1,
  [Fields.WifiAuthType]: 'WPA2',
  [Fields.WifiPassword]: '',
  [Fields.WifiLogin]: '',
};

export interface Timezone {
  label: string;
  tzCode: string;
  name: string;
  utc: string;
}
